<page-content>
  <page-content-header>
  </page-content-header>
  <mat-card>
    <mat-card-content>
      <p>
        ПРИГЛАШЕНИЕ К СОТРУДНИЧЕСТВУ
      </p>
      <div class="card">
        <div class="card-body">
          <p>{{clinic?.name}}</p>
        </div>
      </div>
      <div *ngIf="invite?.status == InviteStatus.Sent">
        <input class="btn btn-primary" type="button" (click)="accept()" value="Принять" />
        <input class="btn btn-danger m-2" type="button" (click)="refuse()" value="Отказать" />
      </div>
      <div *ngIf="invite?.status == InviteStatus.Accepted">
        <div class="card">
          <div class="card-body">
            <div class="alert alert-info">Статус принять отправлено</div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</page-content>
